import './App.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect,useState } from 'react';
import Quote from './pages/quoting/Quote';
import Complete from './pages/quoting/Complete';
import Header from './layouts/Header';
import Banner from "./layouts/Banner";
import Footer from './layouts/Footer';
import Details from "./pages/quoting/Details";
import Vehicles from './pages/quoting/Vehicles';
import Drivers from "./pages/quoting/Drivers";
import Review from './pages/quoting/Review';
import SettingsContext from './store/settingscontext';
import Questions from './pages/quoting/Questions';
import Payment from './pages/quoting/Payment';
import Coverages from './pages/quoting/Coverages';
import Error from './pages/quoting/Error';

function App() {
  const [settings, setSettings] = useState<any>(null);

  useEffect(()=>{
    document.title = (process.env.REACT_APP_SITE_TITLE ?? "Insure");

    setSettings({
      Logo: (process.env.REACT_APP_LOGO ?? "/images/logo-dark.png" )
    });
  }, []);


  return (
    <SettingsContext.Provider value={settings}>
            <link rel="icon" href="/favicon.ico" />

      <div className="App">
        
        <BrowserRouter>
          <Header />
          <Banner/>
          <Routes>
          <Route path="/:id?" element={<Quote></Quote>} />        
          <Route path="/details/:id?" element={<Details></Details>}  />
          <Route path="/vehicles/:id?" element={<Vehicles></Vehicles>} />
          <Route path="/people/:id?" element={<Drivers></Drivers>} />
          
          <Route path="/questions/:id?" element={<Questions></Questions>} />
          <Route path="/payment/:id?" element={<Payment></Payment>} />


          <Route path="/review/:id?" element={<Review></Review>} />
          <Route path='/complete/:id?' element={<Complete></Complete>} />
          <Route path='/coverages' element={<Coverages></Coverages>} />
          <Route path='/error' element={<Error></Error>} />
          </Routes>
          <Banner />
          <Footer />
        </BrowserRouter>

        
      </div>
    </SettingsContext.Provider>
  );
}

export default App;
